import IfopBemEstarNavigation from 'components/markdown/components/IfopBemEstarNavigation'
import IfopConfinementNavigation from 'components/markdown/components/IfopConfinementNavigation'
import IfopCoronaNavigation from 'components/markdown/components/IfopCoronaNavigation'
import IfopDENavigation from 'components/markdown/components/IfopDENavigation'
import IfopEPNavigation from 'components/markdown/components/IfopEPNavigation'
import IfopFetichesNavigation from 'components/markdown/components/IfopFetichesNavigation'
import IfopLibidoNaPademiaNavigation from 'components/markdown/components/IfopLibidoNaPademiaNavigation'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import IfopPaqueraNavigation from 'components/markdown/components/IfopPaqueraNavigation'
import IfopPoliticalSexPositionsNavigation from 'components/markdown/components/IfopPoliticalSexPositionsNavigation'
import IfopSexoVirtualNavigation from 'components/markdown/components/IfopSexoVirtualNavigation'
import IfopTamanhoDoPenisNavigation from 'components/markdown/components/IfopTamanhoDoPenisNavigation'
import IfopToqueRetalNavigation from 'components/markdown/components/IfopToqueRetalNavigation'
import DefaultLayout from 'components/markdown/OperationLayout/Default'
import IfopOperation from 'components/markdown/OperationLayout/IfopOperation'
import { FC } from 'react'

const LAYOUT_TO_LAYOUT_COMP = {
  IfopOperation,
  IfopNavigation,
  IfopDENavigation,
  IfopEPNavigation,
  IfopCoronaNavigation,
  IfopConfinementNavigation,
  IfopPaqueraNavigation,
  IfopToqueRetalNavigation,
  IfopLibidoNaPademiaNavigation,
  IfopTamanhoDoPenisNavigation,
  IfopSexoVirtualNavigation,
  IfopBemEstarNavigation,
  IfopPoliticalSexPositionsNavigation,
  IfopFetichesNavigation
}

interface ChooseLayoutNavigationParams {
  layout?: keyof typeof LAYOUT_TO_LAYOUT_COMP
  navigation?: keyof typeof LAYOUT_TO_LAYOUT_COMP
}

const chooseLayout = (params: ChooseLayoutNavigationParams): FC<any> => {
  if (!params?.layout) return DefaultLayout
  return LAYOUT_TO_LAYOUT_COMP[params.layout]
}
const chooseNavigation = (params: ChooseLayoutNavigationParams): FC<any> => {
  if (!params?.navigation) return IfopNavigation
  return LAYOUT_TO_LAYOUT_COMP[params.navigation]
}
export { chooseLayout, chooseNavigation }
